import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../state-management/rootReducer';

const initialState: TeamMember[] = [];

export const teamMemberSlice = createSlice({
  name: 'teamMembers',
  initialState: initialState,
  reducers: {
    setTeamMembers: (
      state: TeamMember[] = [],
      action: PayloadAction<TeamMember[]>
    ) => {
      return [...action.payload];
    },
    removeTeamMember: (
      state: TeamMember[] = [],
      action: PayloadAction<string>
    ) => {
      return state.filter((teamMember) => teamMember.id !== action.payload);
    },
  },
});

export const { setTeamMembers, removeTeamMember } = teamMemberSlice.actions;

export const getTeamMembers = (state: RootState) => state.teamMembers;

export default teamMemberSlice.reducer;
